export default "__VITE_ASSET__DkJxru5___"